<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                header-row-class-name="headerclass"
                :height="tableHeight"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[7999]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[2078]')" width="400"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('getapi[3629]')" width="150">
                <template slot-scope="scope" >
                    <el-link class="el-button--mini" type="primary"  :href="scope.row.url" :download="scope.row.download">{{scope.row.name}}{{$t('getapi[3629]')}}</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    export default {
        name: 'docdownload',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                userData:[],
                dataSet:[],
            };
        },
        create() {
        },
        beforeMount() {
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.getView();
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6111]"),this.$t("getapi[79]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 获取数据
            getView() {
                let that = this;
                that.dataSet = [{
                    name:this.$t('getapi[8123]'),
                    remark:'',
                    url:'/excel/上传零件模板ver1_2.xlsx',
                    downloadname:'上传零件模板ver1_2.xlsx',
                },{
                    name:this.$t('getapi[8124]'),
                    remark:'',
                    url:'/excel/工艺模板Ver1_1.xlsx',
                    downloadname:'工艺模板Ver1_1.xlsx',
                },{
                    name:this.$t('getapi[8125]'),
                    remark:'',
                    url:'/excel/外来文件Ver1_0.xlsx',
                    downloadname:'外来文件Ver1_0.xlsx',
                },{
                    name:this.$t('getapi[8178]'),
                    remark:'',
                    url:'/excel/工艺装备Ver1_0.xlsx',
                    downloadname:'工艺装备Ver1_0.xlsx',
                },{
                    name:this.$t('getapi[13526]'),
                    remark:'',
                    url:'/excel/质量检验标准模版Ver1_0.xlsx',
                    downloadname:'质量检验标准模版Ver1_0.xlsx',
                }]
            },
        }
    };
</script>

<style lang="scss" scoped>


table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
